
class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('cc-popup-no-scroll');
    this.setAttribute('open', '');
    this.dispatchEvent(new CustomEvent('modal:open'));
  }

  hide() {
    document.body.classList.remove('cc-popup-no-scroll');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    this.dispatchEvent(new CustomEvent('modal:close'));

  }
}
customElements.define('modal-dialog', ModalDialog);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.inputId = this.querySelector('[data-input-id]')
    this.stepIndex = this.closest('[data-step]')?.dataset.step || 0;
    this.form = document.getElementById(this.dataset.formId);
    this.producVariants = JSON.parse(this.querySelector('[data-product-json]').innerHTML)
    this.customTextValue = '';
    this.customTextActive = false;
    this.lastInteractionSource = null;
  }

  connectedCallback() {
    this.setStructures();

    const mainQtyInput = document.getElementById('quantity');
    const customizerQtyInputs = this.querySelectorAll('[data-customizer-quantity]');

    if (mainQtyInput && customizerQtyInputs.length > 0) {
      const updateQty = () => {
        customizerQtyInputs.forEach(input => {
          input.value = mainQtyInput.value;
        });
      };

      updateQty();
      mainQtyInput.addEventListener('input', updateQty);
      mainQtyInput.addEventListener('change', updateQty);
    }

    this.initializeVariant();
    
    this.addEventListener('change', (event) => {
      if (event.target.dataset.property) {
        this.handlePropertyChange(event);
      }
      
      if (this.variant) {
        this.inputId.value = this.variant.id
      }

      this.updateMedia()
      if (!event.target.name) return
      
      this.canvasUtil()
    });

    if (this.propertyOptions.input) {
      this.propertyOptions.input.addEventListener('input', (event) => {
        this.customTextValue = event.target.value;
        this.lastInteractionSource = 'custom';
        this.canvasUtil();
      });

      this.propertyOptions.input.addEventListener('focus', () => {
        this.customTextActive = true;
        this.lastInteractionSource = 'custom';
        this.handlePropertyChange({ target: this.propertyOptions.input });
      });
    }

    this.propertyOptions.checkboxes?.forEach(checkbox => {
      checkbox.addEventListener('click', () => {
        this.lastInteractionSource = 'predefined';
      });
    });
    
    this.canvasUtil()
  }
  
  handlePropertyChange(event) {
    const target = event.target;
    
    this.querySelectorAll('label, input[type="text"]').forEach(el => {
      el.classList.remove('active');
    });
    
    if (target.type === 'radio') {
      this.customTextActive = false;
      this.lastInteractionSource = 'predefined';
      this.propertyOptions.input?.removeAttribute('form');
      
      const label = this.querySelector(`label[for="${target.id}"]`);
      if (label) {
        label.classList.add('active');
      }
      
      this.propertyOptions.checkboxes?.forEach(option => {
        if (option !== target) {
          option.removeAttribute('form');
        } else {
          option.setAttribute('form', this.dataset.formId);
        }
      });
    }
    
    if (target === this.propertyOptions.input) {
      this.customTextActive = true;
      this.lastInteractionSource = 'custom';
      this.propertyOptions.checkboxes?.forEach(option => {
        option.checked = false;
        option.removeAttribute('form');
      });
      target.setAttribute('form', this.dataset.formId);
      target.classList.add('active');
    }
    
    this.canvasUtil();
  }

  initializeVariant() {
    const optionInputs = this.querySelectorAll('fieldset input[type="radio"]');
    if (optionInputs.length > 0) {
      const optionGroups = {};
      
      optionInputs.forEach(input => {
        const optionName = input.dataset.optionName;
        if (!optionGroups[optionName]) {
          optionGroups[optionName] = [];
        }
        optionGroups[optionName].push(input);
      });
      
      Object.values(optionGroups).forEach(group => {
        const anySelected = group.some(input => input.checked);
        if (!anySelected && group.length > 0) {
          group[0].checked = true;
        }
      });
    }
    
    if (this.propertyOptions.input) {
      this.customTextActive = this.propertyOptions.input.classList.contains('active');
      if (this.customTextActive) {
        this.lastInteractionSource = 'custom';
      } else {
        this.lastInteractionSource = 'predefined';
      }
    }
    
    this.updateActiveClasses();
    
    if (this.variant) {
      this.inputId.value = this.variant.id;
      this.updateMedia();
      this.canvasUtil();
    }
  }

  updateActiveClasses() {
    this.querySelectorAll('label, input[type="text"]').forEach(el => {
      el.classList.remove('active');
    });
    
    if (this.lastInteractionSource === 'custom' && this.customTextActive) {
      this.propertyOptions.input?.classList.add('active');
    } else {
      const checkedOption = this.querySelector('input[data-property][type="radio"]:checked');
      if (checkedOption) {
        const label = this.querySelector(`label[for="${checkedOption.id}"]`);
        if (label) {
          label.classList.add('active');
        }
      }
    }
  }

  restoreCustomTextIfNeeded() {
    const tabsContainer = this.closest('[data-step]')?.querySelector('dynamic-form-tabs');
    if (!tabsContainer) return;
    
    const tabElements = Array.from(tabsContainer.querySelectorAll('[role^="tab-"]'));
    const activeTabIndex = tabElements.findIndex(tab => tab.classList.contains('active'));
    
    if (activeTabIndex === 0 && this.customTextValue && this.propertyOptions.input) {
      this.propertyOptions.input.value = this.customTextValue;
      
      if (this.lastInteractionSource === 'custom') {
        this.querySelectorAll('label, input[type="text"]').forEach(el => {
          el.classList.remove('active');
        });
        
        this.propertyOptions.checkboxes?.forEach(option => {
          option.checked = false;
          option.removeAttribute('form');
        });
        
        this.propertyOptions.input.setAttribute('form', this.dataset.formId);
        this.propertyOptions.input.classList.add('active');
      }
    }
  }
  
  update() {
    this.updateLocationOption()
    
    if (this.variant) {
      this.inputId.value = this.variant.id
    } else {
      this.initializeVariant();
    }
    
    this.updateMedia()
    
    this.restoreCustomTextIfNeeded();
    this.updateActiveClasses();
    
    setTimeout(() => {
      this.canvasUtil()
    }, 50);
  }

  canvasUtil() {
    if (!this.closest('[data-step]')) return;
    const canvas = this.closest('[data-step]').querySelector('canvas');
    if (!canvas) {
      console.warn('Canvas not found');
      return;
    }
  
    const ctx = canvas.getContext("2d");
    let imageSrc, imageWidth, imageHeight;
    
    const tabsContainer = this.closest('[data-step]')?.querySelector('dynamic-form-tabs');
    const tabElements = tabsContainer ? Array.from(tabsContainer.querySelectorAll('[role^="tab-"]')) : [];
    const activeTabIndex = tabElements.findIndex(tab => tab.classList.contains('active'));
    const isLastTab = activeTabIndex === tabElements.length - 1;
    
    const activeTab = tabElements[activeTabIndex];
    const labelImage = activeTab?.dataset?.labelImage?.trim();
    const nonLabelImage = activeTab?.dataset?.nonLabelImage?.trim();
    const selectedLocationValue = this.querySelector('fieldset input[data-option-name*="location"]:checked')?.value?.toLowerCase() || '';
    const variantSideValue = this.variant?.option2?.toLowerCase() || '';
    const locationValue = selectedLocationValue || variantSideValue;

    if (isLastTab) {
      const customImageSrc = activeTab?.dataset?.customImage?.trim();
      
      if (customImageSrc) {
        imageSrc = customImageSrc;
        imageWidth = null;
        imageHeight = null;
      }
    } else if (labelImage || nonLabelImage) {
      if (locationValue.includes('non-label') && nonLabelImage) {
        imageSrc = nonLabelImage;
        imageWidth = 1384;
        imageHeight = 1000;
      } else if ((locationValue.includes('label') || locationValue.includes('bar')) && labelImage) {
        imageSrc = labelImage;
        imageWidth = 1384;
        imageHeight = 1000;
      } else if (labelImage) {
        imageSrc = labelImage;
        imageWidth = 1384;
        imageHeight = 1000;
      } else if (nonLabelImage) {
        imageSrc = nonLabelImage;
        imageWidth = 1384;
        imageHeight = 1000;
      }
    }

    if (!imageSrc) {
      imageSrc = canvas.dataset.imageSrc;
      imageWidth = canvas.dataset.imageWidth;
      imageHeight = canvas.dataset.imageHeight;
    }

    if (!imageSrc) {
      console.warn('Missing image source');
      return;
    }

    imageSrc = imageSrc.trim();
  
    const bgImg = new Image();
    bgImg.crossOrigin = "anonymous";
    bgImg.src = imageSrc;
  
    bgImg.onload = () => {
      if (!this.canvasData) {
        console.warn('Canvas data not available');
        return;
      }
      
      if (isLastTab && !imageWidth && !imageHeight) {
        imageWidth = bgImg.naturalWidth;
        imageHeight = bgImg.naturalHeight;
        
        canvas.dataset.imageSrc = imageSrc;
        canvas.dataset.imageWidth = imageWidth;
        canvas.dataset.imageHeight = imageHeight;
      }
      
      canvas.width = +imageWidth;
      canvas.height = +imageHeight;
  
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(bgImg, 0, 0, canvas.width, canvas.height);
  
      const baseFontSize = 25 * (canvas.width / canvas.offsetWidth);
      const fontSize = isLastTab ? baseFontSize + 310 : baseFontSize;
      ctx.font = `${fontSize}px Helvetica`;
      ctx.textBaseline = "middle";
  
      let color = '#000000';
      if (isLastTab) {
        color = '#FFFFFF';
      } else {
        const selectedSwatch = document.querySelector('.customizer-drawer .customizer-drawer__step:not(.hidden) .opt-btn:checked+.opt-label[data-swatch]');
        if (selectedSwatch) {
          color = getComputedStyle(selectedSwatch).getPropertyValue('--swatch-background-color').trim() ? getComputedStyle(selectedSwatch).getPropertyValue('--swatch-background-color').trim() : '#FFFFFF';
        }
      }
      ctx.fillStyle = color;
  
      const { text } = this.canvasData;
      if (!text) {
        console.warn('No text to render on canvas');
        return;
      }
      
      this.updateTextSourceActiveClass();
      
      const temp = document.createElement('div');
      temp.innerHTML = text;
      const span = temp.querySelector('.opt-label__text');
      const rawText = (span?.childNodes[0]?.textContent || text).trim().toUpperCase();
  
      const letterSpacing = isLastTab ? -15 : 0;
      const charWidths = [...rawText].map(ch => ctx.measureText(ch).width);
      const textWidth = charWidths.reduce((sum, w) => sum + w, 0) + letterSpacing * (rawText.length - 1);
  
      const imgEl = span?.querySelector('img');
      const hasIcon = !!imgEl?.src;
      const iconHeight = hasIcon ? fontSize : 0;
      const iconWidth = hasIcon ? (iconHeight * (imgEl.naturalWidth || 1) / (imgEl.naturalHeight || 1)) : 0;
      const padding = hasIcon ? 15 : 0; 
      
      const showIconOnly = hasIcon;
      
      const totalWidth = showIconOnly ? iconWidth : (textWidth + padding + iconWidth);
      
      let xStart, textAlign;
      
      if (isLastTab) {
        xStart = 100;
        textAlign = 'left';
      } else {
        const selectedLocation = this.querySelector('fieldset input[data-option-name*="location"]:checked');
        const selectedLocationText = selectedLocation?.value?.toLowerCase() || '';
        if (selectedLocationText.includes('non-label')) {
          xStart = 325;
          textAlign = 'left';
        } else {
          xStart = canvas.width - 345;
          textAlign = 'right';
        }
      }
      
      let drawX;
      if (textAlign === 'left') { 
        drawX = xStart;
      } else {
        drawX = xStart - totalWidth;
      }
      
      const isLargeScreen = window.innerWidth > 768;
      const yOffset = isLastTab? 20 : 0;
      const textY = isLastTab ? canvas.height / 2 + yOffset : canvas.height / 2;
      
      if (!showIconOnly) {
        let currentX = drawX;
        rawText.split('').forEach((ch, i) => {
          ctx.fillText(ch, currentX, textY);
          currentX += charWidths[i] + letterSpacing;
        });
      }
  
      if (hasIcon) {
        let iconX;
        if (showIconOnly) {
          if (textAlign === 'left') {
            iconX = xStart;
          } else {
            const divisor = window.innerWidth > 768 ? 5 : 7;
            iconX = xStart - canvas.width / divisor;
          }
        }
        
        const icon = new Image();
        icon.crossOrigin = "anonymous";
        icon.src = imgEl.src;
  
        icon.onload = () => {
          if (!icon.naturalHeight) {
            console.warn("Invalid icon dimensions");
            return;
          }
          
          const aspectRatio = icon.naturalWidth / icon.naturalHeight;
          const actualIconWidth = iconHeight * aspectRatio;
  
          const offCanvas = document.createElement('canvas');
          offCanvas.width = actualIconWidth;
          offCanvas.height = iconHeight;
          const offCtx = offCanvas.getContext('2d');
          offCtx.drawImage(icon, 0, 0, actualIconWidth, iconHeight);
          const imageData = offCtx.getImageData(0, 0, actualIconWidth, iconHeight);
          const data = imageData.data;
  
          let hex = color.replace('#', '');
          if (hex.length === 3) {
            hex = hex.split('').map(ch => ch + ch).join('');
          }
          const rNew = parseInt(hex.slice(0, 2), 16);
          const gNew = parseInt(hex.slice(2, 4), 16);
          const bNew = parseInt(hex.slice(4, 6), 16);
  
          for (let i = 0; i < data.length; i += 4) {
            data[i]     = rNew; // R
            data[i + 1] = gNew; // G
            data[i + 2] = bNew; // B
          }
          offCtx.putImageData(imageData, 0, 0);
  
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(bgImg, 0, 0, canvas.width, canvas.height);
          
          if (!showIconOnly) {
            ctx.fillStyle = color;
            ctx.textAlign = 'left';
            let xChar = drawX;
            rawText.split('').forEach((ch, i) => {
              ctx.fillText(ch, xChar, textY);
              xChar += charWidths[i] + letterSpacing;
            });
          }
          
          const iconY = textY - iconHeight / 2;
          ctx.drawImage(offCanvas, iconX, iconY);
        };
  
        icon.onerror = () => console.warn("Failed to load icon");
      }
    };
  
    bgImg.onerror = () => console.error("Background image failed to load.");
  }

  updateTextSourceActiveClass() {
    this.querySelectorAll('label, input[type="text"]').forEach(el => {
      el.classList.remove('active');
    });
    
    const tabsContainer = this.closest('[data-step]')?.querySelector('dynamic-form-tabs');
    if (!tabsContainer) return;
    
    const tabElements = Array.from(tabsContainer.querySelectorAll('[role^="tab-"]'));
    const activeTabIndex = tabElements.findIndex(tab => tab.classList.contains('active'));
    
    if (activeTabIndex === 0) {
      if (this.lastInteractionSource === 'custom') {
        this.propertyOptions.input?.classList.add('active');
      } else {
        const selectedInput = this.querySelector('input[data-property][type="radio"]:checked');
        if (selectedInput) {
          const label = this.querySelector(`label[for="${selectedInput.id}"]`);
          if (label) {
            label.classList.add('active');
          }
        }
      }
    } else if (activeTabIndex === 1) {
      const selectedInput = this.querySelector('input[data-option-name="embroidery"]:checked');
      if (selectedInput) {
        const label = this.querySelector(`label[for="${selectedInput.id}"]`);
        if (label) {
          label.classList.add('active');
        }
      }
    }
  }

  updateLocationOption() {
    const stepIndex = parseInt(this.closest('[data-step]')?.dataset.step || '0');
    
    if (stepIndex === 0) {
      const locationOptions = [...this.querySelectorAll('fieldset input[data-option-name*="location"]')];
      locationOptions.forEach(option => {
        option.disabled = false;
      });
      return;
    }
    
    const step1 = document.querySelector('[data-step="0"]');
    if (!step1) return;
    
    const usedLocations = [...step1.querySelectorAll('fieldset input[data-option-name*="location"]:checked')].map(option => option.value);
    if (usedLocations.length === 0) return;

    const locationOptions = [...this.querySelectorAll('fieldset input[data-option-name*="location"]')];
    locationOptions.forEach(option => {
      option.disabled = usedLocations.includes(option.value);
    });
    
    const selectedOption = this.querySelector('fieldset input[data-option-name*="location"]:checked');
    if (selectedOption && selectedOption.disabled) {
      const firstAvailableOption = locationOptions.find(option => !option.disabled);
      if (firstAvailableOption) {
        firstAvailableOption.checked = true;
        this.dispatchEvent(new Event('change'));
      }
    }
  }

  updateMedia() {
    if (!this.variant || !this.variant.featured_image) {
      console.warn('No variant or featured image available for updateMedia');
      return;
    }
    
    const canvas = this.closest('[data-step]')?.querySelector('canvas');
    if (!canvas) {
      console.warn('Canvas not found for updateMedia');
      return;
    }
    
    const tabsContainer = this.closest('[data-step]')?.querySelector('dynamic-form-tabs');
    const tabElements = tabsContainer ? Array.from(tabsContainer.querySelectorAll('[role^="tab-"]')) : [];
    const activeTabIndex = tabElements.findIndex(tab => tab.classList.contains('active'));
    const isLastTab = activeTabIndex === tabElements.length - 1;
    
    if (isLastTab) {
      const activeTab = tabElements[activeTabIndex];
      const customImageSrc = activeTab?.dataset?.customImage?.trim();
      
      if (customImageSrc) {
        canvas.setAttribute("data-image-src", customImageSrc);
        return;
      }
    }
    
    canvas.setAttribute("data-image-src", this.variant.featured_image.src);
    canvas.setAttribute("data-image-width", this.variant.featured_image.width);
    canvas.setAttribute("data-image-height", this.variant.featured_image.height);
  }

  get canvasData() {
    const formData = new FormData(this.form);
    const stepIndex = +this.stepIndex + 2;

    const tabsContainer = this.closest('[data-step]')?.querySelector('dynamic-form-tabs');
    if (!tabsContainer) {
      console.warn('No tabs container found');
      return { text: '', color: "#000000" };
    }
    
    const tabElements = Array.from(tabsContainer.querySelectorAll('[role^="tab-"]'));
    const activeTabIndex = tabElements.findIndex(tab => tab.classList.contains('active'));
    const tabsCount = tabElements.length;

    let textContent = '';

    if (activeTabIndex === 0) {
      if (this.lastInteractionSource === 'custom') {
        textContent = formData.get(`items[${stepIndex}]properties[text]`) || this.customTextValue || '';
      } else {
        const selectedInput = this.querySelector('input[data-property][type="radio"]:checked');
        if (selectedInput) {
          const label = this.querySelector(`label[for="${selectedInput.id}"]`);
          if (label) {
            textContent = label.textContent.trim();
          }
        }
      }
    } else if (activeTabIndex === 1) {
      const selectedInput = this.querySelector('input[data-option-name="embroidery"]:checked');
      if (selectedInput) {
        const label = this.querySelector(`label[for="${selectedInput.id}"]`);
        const labelContent = label?.querySelector('.opt-label__text');
        textContent = labelContent?.outerHTML || '';
      }
    } else if (activeTabIndex === tabsCount - 1) {
      textContent = formData.get(`items[${stepIndex}]properties[stripes]`) || '';
    }
    
    return {
      text: textContent,
      color: this.querySelector('fieldset input[data-option-name="color"]:checked')?.value || "#000000",
    };
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input[name]:not([data-property]):checked')).map(
      (option) => option.value
    );
  }
  
  get variant() {
    return this.producVariants.find(variant => {
      const allOptionsMatch = this.selectedOptionValues.every(selectedOption => 
        variant.options.includes(selectedOption)
      );
      
      const optionCountMatches = this.selectedOptionValues.length === variant.options.length;
      
      return allOptionsMatch && optionCountMatches;
    });
  }

  setStructures() {
    this.propertyOptions = {
      checkboxes: this.querySelectorAll('[data-property][type="radio"]'),
      input: this.querySelector('[data-property][type="text"]'),
    }
  }
}

customElements.define('variant-selects', VariantSelects);
class CustomizerDrawer extends HTMLElement {
  currentStep = 0

  constructor() {
    super();
    this.initialize();
  }

  initialize() {
    this.setStructures();
    this.navigationUtil();
    this.setUniqProperty();
    this.toggleWrapper(false);
    this.disableNonCurrentSteps();

    this.closest("modal-dialog")?.addEventListener('modal:open', () => {
      this.toggleWrapper(true);
      
      this.initializeAllVariantSelects();
      this.syncQuantityValues(); 
      
      this.updatePrice();
      this.resetToFirstStep();
    });

    this.closest("modal-dialog")?.addEventListener('modal:close', () => {
      this.toggleWrapper(false);
    });

    this.addEventListener('tab-changed', this.handleTabChange.bind(this));
  }

  syncQuantityValues() {
    const mainQuantityInput = document.querySelector('.quantity-submit-row [name="quantity"]');
    if (!mainQuantityInput) return;
    
    const quantityValue = mainQuantityInput.value;
    
    const drawerQuantityInputs = this.querySelectorAll('input[type="number"]');
    drawerQuantityInputs.forEach(input => {
      input.value = mainQuantityInput.value;
    });
  }

  initializeAllVariantSelects() {
    const allVariantSelects = this.querySelectorAll('variant-selects');
    allVariantSelects.forEach(variantSelect => {
      if (typeof variantSelect.initializeVariant === 'function') {
        variantSelect.initializeVariant();
      }
      
      if (typeof variantSelect.update === 'function') {
        variantSelect.update();
      }
    });
  }

  resetToFirstStep() {
    this.currentStep = 0;
    this.disableNonCurrentSteps();
    this.updateNavigationButtons();
    
    const currentStepElement = this.steps[this.currentStep];
    if (currentStepElement?.wrapper) {
      const variantSelects = currentStepElement.wrapper.querySelector('variant-selects');
      if (variantSelects && typeof variantSelects.update === 'function') {
        variantSelects.update();
      }
    }
  }
  

  handleTabChange(event) {
    event.stopPropagation();
    this.setStructures();
    this.navigationUtil();
    this.setUniqProperty();
    this.disableNonCurrentSteps(); 
    this.updatePrice();
    
    const currentStepElement = this.steps[this.currentStep];
    if (currentStepElement?.wrapper) {
      const variantSelects = currentStepElement.wrapper.querySelector('variant-selects');
      if (variantSelects) {
        variantSelects.update();
      }
    }
  }

  disableNonCurrentSteps() {
    this.steps.forEach((step, index) => {
      const isCurrent = index === this.currentStep;

      if (step.wrapper) {
        step.wrapper.classList.toggle('hidden', !isCurrent);
      } else {
        console.warn(`⚠️ wrapper не найден на шаге ${index}`);
      }

      if (index === 1 && this.currentStep === 0) {
        const inputs = step.wrapper?.querySelectorAll('input, select, textarea, button, [data-property]') || [];
        inputs.forEach(input => {
          input.disabled = true;
        });
      } else {
        const inputs = step.wrapper?.querySelectorAll('input, select, textarea, button, [data-property]') || [];
        inputs.forEach(input => {
          input.disabled = false;
        });
      }
    });

    this.updateNavigationButtons();
  }

  updateNavigationButtons() {
    if (!this.navigation) return;

    this.navigation.prevButtons.forEach(prevButton => {
      prevButton.classList.toggle('hidden', this.currentStep == 0);
    });

    this.navigation.nextButtons.forEach(nextButton => {
      nextButton.classList.toggle('hidden', this.currentStep != 1);
    });

    this.navigation.prevButtons.forEach(prevButton => {
      prevButton.classList.toggle('hidden', this.currentStep != 1);
    });

    this.navigation.nextButtons.forEach(nextButton => {
      nextButton.classList.toggle('hidden', this.currentStep == 1);
    });
  }

  setUniqProperty() {
    const uniqId = new Date().getTime();
    this.uniqProperties.forEach(property => property.value = uniqId);
  }

  toggleWrapper(state) {
    this.wrapper = this.wrapper || this.querySelector('[data-wrapper]');
    state ? this.appendChild(this.wrapper) : this.wrapper.remove();
  }

  updatePrice() {
    const currentPrice = theme.OptionManager.currentVariantData()?.price || 0;
    this.priceData.wrappers.forEach((wrapper, index) => {
      wrapper.total = window.Shopify.formatMoney(currentPrice + this.priceData.price * (index + 1));
    });
  }

  navigationUtil() {
    this.navigation.nextButtons.forEach(button => {
      button.addEventListener('click', this.navigationHandler.bind(this));
    });

    this.navigation.prevButtons.forEach(button => {
      button.addEventListener('click', this.navigationHandler.bind(this));
    });
  }

  navigationHandler(event) {
    const isNext = this.navigation.nextButtons.includes(event.currentTarget);
    const direction = isNext ? 1 : -1;
    const newStep = this.currentStep + direction;

    if (newStep >= 0 && newStep < this.steps.length) {
      this.currentStep = newStep;
      this.disableNonCurrentSteps();

      const currentStep = this.steps[this.currentStep];
      currentStep?.wrapper?.querySelector('variant-selects')?.update();

      this.steps.forEach((step, index) => {
        step.priceWrapper?.classList.toggle('hidden', index !== this.currentStep);
      });
    }
  }

  setStructures() {
    this.steps = [...this.querySelectorAll('[data-step]')].map((step, index) => ({
      wrapper: step,
      inputId: step.querySelector('[data-input-id]'),
      uniqIdInput: step.querySelector('[data-uniq-id]'),
      priceWrapper: document.querySelector(`[data-step-price="${index}"]`)
    }));

    this.navigation = {
      nextButtons: [...this.querySelectorAll('[data-navigation="next"]')],
      prevButtons: [...this.querySelectorAll('[data-navigation="prev"]')]
    };

    this.priceData = {
      price: this.dataset.price,
      wrappers: [...this.querySelectorAll('[data-step-price]')].map(priceWrapper => ({
        product: priceWrapper.querySelector("[data-product-price] .money"),
        custom: priceWrapper.querySelector("[data-custom-price] .money"),
        total: priceWrapper.querySelector("[data-total-price] .money")
      }))
    };

    this.uniqProperties = [...this.querySelectorAll('[data-uniq-id]')];
  }
}

customElements.define('customizer-drawer', CustomizerDrawer);

var DynamicFormTabs = class extends HTMLElement {
  constructor() {
    super();
    this._tabContentCache = null;
  }

  get tabContentCache() {
    if (!this._tabContentCache) {
      this._tabContentCache = {};
      this.initializeCache();
    }
    return this._tabContentCache;
  }

  connectedCallback() {
    this.tabButtons = this.querySelectorAll('[role^="tab-"]');
    this.tabContentContainer = this.closest('.customizer-drawer__step').querySelector('[role^="tabcontent-"]');

    if (!this.tabContentContainer) {
      console.error('No tab content container found');
      return;
    }
    this.addEventListener('click', this.handleTabClick.bind(this));
    this.initActiveTab();
  }

  initializeCache() {
    this.tabButtons.forEach(button => {
      const role = button.getAttribute('role');
      const contentId = role.replace('tab-', 'tabcontent-');
      const content = this.closest('.customizer-drawer__step').querySelector(`[role="${contentId}"]`);
      if (content) {
        this._tabContentCache[role] = content.innerHTML;
      }
    });

    Object.freeze(this._tabContentCache);
    this.removeAllFormsFromDOM();
  }

  initActiveTab() {
    const activeButton = Array.from(this.tabButtons).find(btn => btn.classList.contains('active'));

    if (!activeButton && this.tabButtons.length > 0) {
      this.tabButtons[0].classList.add('active');
      this.showTabContent(this.tabButtons[0]);
      this.updateLabelTypeInput(this.tabButtons[0]);
    } else if (activeButton) {
      this.showTabContent(activeButton);
      this.updateLabelTypeInput(activeButton);
    }
  }

  handleTabClick(event) {
    const clickedButton = event.target.closest('[role^="tab-"]');
    if (!clickedButton) return;

    event.preventDefault();
    if (clickedButton.classList.contains('active')) return;

    this.tabButtons.forEach(btn => btn.classList.remove('active'));
    clickedButton.classList.add('active');
    this.showTabContent(clickedButton);
    this.updateLabelTypeInput(clickedButton);
  }

  removeAllFormsFromDOM() {
    const activeRole = this.tabButtons[0]?.getAttribute('role');
    const activeContentId = activeRole?.replace('tab-', 'tabcontent-');

    this.tabButtons.forEach(button => {
      const role = button.getAttribute('role');
      const contentId = role.replace('tab-', 'tabcontent-');

      if (contentId === activeContentId) return;

      const content = this.closest('.customizer-drawer__step')?.querySelector(`[role="${contentId}"]`);
      if (content) content.remove();
    });
  }

  showTabContent(activeButton) {
    const buttonRole = activeButton.getAttribute('role');
    const cachedContent = this.tabContentCache[buttonRole];

    if (!cachedContent) {
      console.error(`Content for tab "${buttonRole}" not found in cache`);
      return;
    }

    this.tabContentContainer.innerHTML = cachedContent;
    this.enableInputsInContent();

    this.dispatchEvent(new CustomEvent('tab-changed', {
      bubbles: true,
      detail: {
        button: activeButton,
        content: this.tabContentContainer,
        buttonRole: buttonRole
      }
    }));
  }

  enableInputsInContent() {
    const dataInputs = this.tabContentContainer.querySelectorAll(`
          [data-input-id][data-uniq-id],
          [data-uniq-id][data-input-id]
      `);

    dataInputs.forEach(input => {
      input.removeAttribute('disabled');
    });
    const itemIdInput = this.tabContentContainer.querySelector('input[name="items[2][id]"]');
    const itemUniqInput = this.tabContentContainer.querySelector('input[name="items[2][properties][uniq]"]');

    if (itemIdInput) itemIdInput.removeAttribute('disabled');
    if (itemUniqInput) itemUniqInput.removeAttribute('disabled');
  }

  updateLabelTypeInput(activeButton) {
    const labelTypeInput = this.closest('.customizer-drawer__step').querySelector('[data-label-type]');
    if (!labelTypeInput) return;

    const tabName = activeButton.textContent.trim() || activeButton.getAttribute('data-tab-name') || '';
    labelTypeInput.value = tabName;

    labelTypeInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
};
